import './Pocetna.css';

function Pocetna() {
  return (
    <div style={{ overflow: 'hidden' }}>
      <div className="title_panel">
        <span className="title">my Inmold</span>
      </div>
    </div>
  );
}

export default Pocetna;
